const Sizes = {
  // Liczby w App.less (--side-menu-width) — na telefonie trzymanym pionowo menu jest węższe
  SIDE_MENU: 'var(--side-menu-width)',
  AVAILABLE_PAGE_SIZES: ['9', '18', '27'],
  SIDE_LIST: '333px',
};

export default Sizes;
